import { HtmlGenerator, PdfFile } from '@utils';
import { fonts } from 'fonts';
import { store } from '../store';
import { SubmissionEntityInterface } from '@types';

export const generatePdf = async (
  isAttachmentPdf: boolean,
  letterName: string,
  submission: SubmissionEntityInterface
) => {
  const submissionEnvironment = store?.getState().submissionEnvironment;

  const html = new HtmlGenerator(
    `
          <div style="height: 842px;">
            ${fonts}
            <style>
              body {
                background-color: #f1f4f5;
                margin-left: -1px;
                margin-top: 0;
              }
            </style>
            <div style="zoom: 0.9;">${submission.origin.formRenderer.data}</div>
          </div>
        `,
    { ...submissionEnvironment, isDownload: true, scale: 1 }
  ).getHtml();

  const downloadLink = document.createElement('a');
  const fileName = letterName ? `${letterName}.pdf` : `${submission.origin.form.name}.pdf`;
  const {
    format = 'A4',
    landscape = false,
    pageRanges = '',
  } = JSON.parse(submission.origin.form.data || '{}');
  const options = {
    format,
    landscape,
    pageRanges,
  };

  if (!isAttachmentPdf) {
    downloadLink.href = `data:application/pdf;base64,${await new PdfFile(html).convertToPdf(
      options
    )}`;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  if (isAttachmentPdf) {
    return await new PdfFile(html).convertToPdf(options);
  }
};
